const STAR_VIEWBOX_SIZE = 40;
const STAR_SHAPE_PATH =
  "M23.5366 16.6367H34.979L25.7212 23.3633V23.3643L20.8169 26.875L26.2075 24.8594L29.2573 34.2461L20.0005 27.5195L10.7427 34.2461L14.2788 23.3633L5.021 16.6367H16.4644L20.0005 5.75391L23.5366 16.6367Z";
export type TrustpilotStarVariant = "full" | "half" | "empty";

export function getStarVariants(rating: number, starCount: number): TrustpilotStarVariant[] {
  const halfSteps = Math.max(0, Math.min(Math.round(rating * 2), starCount * 2));
  return Array.from({ length: starCount }, (_, i): TrustpilotStarVariant => {
    const remaining = halfSteps - i * 2;
    if (remaining >= 2) return "full";
    if (remaining === 1) return "half";
    return "empty";
  });
}

export const TrustpilotStar = ({
  variant,
  className = "h-5 w-5",
}: {
  variant: TrustpilotStarVariant;
  className?: string;
}) => {
  const isEmptyStar = variant === "empty";
  const isHalfStar = variant === "half";

  return (
    <svg
      aria-hidden="true"
      className={className}
      width={STAR_VIEWBOX_SIZE}
      height={STAR_VIEWBOX_SIZE}
      viewBox={`0 0 ${STAR_VIEWBOX_SIZE} ${STAR_VIEWBOX_SIZE}`}
    >
      <rect width={STAR_VIEWBOX_SIZE} height={STAR_VIEWBOX_SIZE} fill={isEmptyStar ? "#DBDBE3" : "#00B57A"} />
      {isHalfStar ? (
        <rect x={STAR_VIEWBOX_SIZE / 2} width={STAR_VIEWBOX_SIZE / 2} height={STAR_VIEWBOX_SIZE} fill="#DBDBE3" />
      ) : null}
      <path d={STAR_SHAPE_PATH} fill="white" />
    </svg>
  );
};
